/* eslint-disable */

<template>
  <div>
    <div class="vx-row">

      <div class="vx-col lg:w-4/12 md:w-5/12 sm:w-5/5 mb-4">
        <div class="flex gap-2 mb-2">
          <vs-button :color="sel==='r1'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r1'">R1</vs-button>
          <vs-button :color="sel==='r2'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r2'">R2</vs-button>
          <vs-button :color="sel==='r3'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r3'">R3</vs-button>
        </div>

        <vx-card style="height: 42rem; overflow-y: auto">

          <!-- Task 1 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task1Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task1Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task1Done?'#28C76F':'#4a5568'}">1</span>
              <span class="font-semibold text-sm flex-1">Host Route Static Routing (R3 → R1 Loopback)</span>
              <span class="text-xs font-medium" :class="task1Done?'text-success':'text-grey'">{{ task1Progress }}/4</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="rKey in ['r3','r2','r1']" :key="'t1-'+rKey" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ rKey.toUpperCase() }}</span>
                <div class="space-y-1 ml-1">
                  <div v-for="item in (rKey==='r3'?task1R3Items:rKey==='r2'?task1R2Items:task1R1Items)" :key="rKey+'-'+item.key" class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:getCompletion(rKey)[item.key]?'#28C76F':'transparent',border:'2px solid '+(getCompletion(rKey)[item.key]?'#28C76F':'#6b7280')}"></div>
                    <code class="text-base" :class="getCompletion(rKey)[item.key]?'text-success':''">{{ item.cmd }}</code>
                  </div>
                </div>
              </div>
              <div class="mt-1">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">Verify — R3</span>
                <div class="space-y-1 ml-1 mt-1">
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:r3Completion.pingVerify?'#28C76F':'transparent',border:'2px solid '+(r3Completion.pingVerify?'#28C76F':'#6b7280')}"></div>
                    <code class="text-base" :class="r3Completion.pingVerify?'text-success':''">ping 192.168.1.1</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 2 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task2Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task2Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task2Done?'#28C76F':'#4a5568'}">2</span>
              <span class="font-semibold text-sm flex-1">IPv4 Default Route on R2 → R4</span>
              <span class="text-xs font-medium" :class="task2Done?'text-success':'text-grey'">{{ task2Done?1:0 }}/1</span>
            </div>
            <div class="px-3 py-2 space-y-1">
              <div class="flex items-center gap-2">
                <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:r2Completion.ipDefaultRoute?'#28C76F':'transparent',border:'2px solid '+(r2Completion.ipDefaultRoute?'#28C76F':'#6b7280')}"></div>
                <code class="text-base" :class="r2Completion.ipDefaultRoute?'text-success':''">ip route 0.0.0.0 0.0.0.0 209.165.202.130</code>
              </div>
            </div>
          </div>

          <!-- Task 3 -->
          <div class="rounded-lg mb-2 overflow-hidden" :style="{border:'1px solid '+(task3Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task3Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task3Done?'#28C76F':'#4a5568'}">3</span>
              <span class="font-semibold text-sm flex-1">IPv6 Default Route on R2 → R4</span>
              <span class="text-xs font-medium" :class="task3Done?'text-success':'text-grey'">{{ task3Done?1:0 }}/1</span>
            </div>
            <div class="px-3 py-2 space-y-1">
              <div class="flex items-center gap-2">
                <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:r2Completion.ipv6DefaultRoute?'#28C76F':'transparent',border:'2px solid '+(r2Completion.ipv6DefaultRoute?'#28C76F':'#6b7280')}"></div>
                <code class="text-base" :class="r2Completion.ipv6DefaultRoute?'text-success':''">ipv6 route ::/0 2001:db8:abcd::2</code>
              </div>
            </div>
          </div>

        </vx-card>
      </div>

      <div class="vx-col lg:w-8/12 md:w-7/12 sm:w-5/5">
        <div style="height: 35rem">
          <vue-command v-show="sel==='r1'" key="r1" id="r1_terminal" :commands="r1Commands" :prompt="r1Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R1" />
          <vue-command v-show="sel==='r2'" key="r2" id="r2_terminal" :commands="r2Commands" :prompt="r2Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R2" />
          <vue-command v-show="sel==='r3'" key="r3" id="r3_terminal" :commands="r3Commands" :prompt="r3Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R3" />
        </div>

        <!-- Topology -->
        <div class="topology-card">
          <img :src="topologyImage" alt="Network topology" class="topology-img" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

const HELP = 'Type commands as shown in the task checklist.';

const mkCommands = (rk, vm) => ({
  help:      () => createStdout(HELP),
  enable:    () => createStdout(''),
  configure: (x) => vm.iosConfigure(rk, x),
  conf:      (x) => vm.iosConfigure(rk, x),
  exit:      () => vm.iosExit(rk),
  end:       () => vm.iosEnd(rk),
  ip:        (x) => vm.iosIp(rk, x),
  ipv6:      (x) => vm.iosIpv6(rk, x),
  ping:      (x) => vm.iosPing(rk, x),
});

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      topologyImage: 'https://ip-learn.b-cdn.net/simulations/ccna-topologies/Static_Routing_Configuration_Sim_3.png',
      sel: 'r3',
      totalScore: 0,

      task1R3Items: [{ key: 'ipRoute', cmd: 'ip route 192.168.1.1 255.255.255.255 209.165.200.229' }],
      task1R2Items: [{ key: 'ipRoute', cmd: 'ip route 192.168.1.1 255.255.255.255 209.165.200.225' }],
      task1R1Items: [{ key: 'ipRoute', cmd: 'ip route 209.165.200.230 255.255.255.255 209.165.200.226' }],

      r1: { mode: 'exec' },
      r2: { mode: 'exec' },
      r3: { mode: 'exec' },

      r1Completion: { ipRoute: false },
      r2Completion: { ipRoute: false, ipDefaultRoute: false, ipv6DefaultRoute: false },
      r3Completion: { ipRoute: false, pingVerify: false },

      r1Commands: null,
      r2Commands: null,
      r3Commands: null,
    };
  },

  computed: {
    r1Prompt() { return this.r1.mode === 'config' ? 'R1(config)#' : 'R1#'; },
    r2Prompt() { return this.r2.mode === 'config' ? 'R2(config)#' : 'R2#'; },
    r3Prompt() { return this.r3.mode === 'config' ? 'R3(config)#' : 'R3#'; },
    task1Progress() {
      return (this.r3Completion.ipRoute ? 1 : 0) +
             (this.r2Completion.ipRoute ? 1 : 0) +
             (this.r1Completion.ipRoute ? 1 : 0) +
             (this.r3Completion.pingVerify ? 1 : 0);
    },
    task1Done() { return !!this.r3Completion.pingVerify; },
    task2Done() { return !!this.r2Completion.ipDefaultRoute; },
    task3Done() { return !!this.r2Completion.ipv6DefaultRoute; },
  },

  watch: {
    'r3Completion.ipRoute'(val)    { if (val) this.switchTo('r2'); },
    'r2Completion.ipRoute'(val)    { if (val) this.switchTo('r1'); },
    'r1Completion.ipRoute'(val)    { if (val) this.switchTo('r3'); },
    'r3Completion.pingVerify'(val) { if (val) this.switchTo('r2'); },
  },

  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
    this.r1Commands = mkCommands('r1', this);
    this.r2Commands = mkCommands('r2', this);
    this.r3Commands = mkCommands('r3', this);
  },

  methods: {
    getState(k)      { return this[k]; },
    getCompletion(k) { return this[k + 'Completion']; },

    guide(msg) {
      return `<span style="color:#28C76F;display:block;margin-top:6px;padding:4px 8px;border-left:2px solid #28C76F;font-size:0.85em;line-height:1.5">${msg}</span>`;
    },
    switchTo(r) {
      this.sel = r;
      this.$nextTick(() => {
        const el = document.querySelector(`#${r}_terminal input, #${r}_terminal textarea`);
        if (el) el.focus();
      });
    },

    modeErr(state, needed) {
      if (state.mode === needed) return null;
      if (needed === 'config') return createStderr('% Must be in configuration mode — type "configure terminal" first');
      if (needed === 'exec')   return createStderr('% Must be in privileged EXEC mode — type "end" first');
      return createStderr('% Invalid input detected');
    },

    updateScore() {
      let score = 0;
      [this.r1Completion, this.r2Completion, this.r3Completion].forEach(c => Object.values(c).forEach(v => { if (v) score++; }));
      this.totalScore = score;
      this.$forceUpdate();
      this.$emit('simulation_update_score', score);
      if (score >= 6) setTimeout(() => this.$emit('simulation_full_correct', score), 500);
    },

    iosConfigure(rk, x) {
      const me = this.modeErr(this[rk], 'exec'); if (me) return me;
      if (x._[1] === 'terminal' || x._[1] === 't') {
        this[rk].mode = 'config';
        return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.');
      }
      return createStderr('% Invalid input detected');
    },

    iosExit(rk) {
      if (this[rk].mode === 'config') this[rk].mode = 'exec';
      return createStdout('');
    },

    iosEnd(rk) { this[rk].mode = 'exec'; return createStdout(''); },

    iosIp(rk, x) {
      const s = this[rk]; const c = this[rk + 'Completion'];
      if (x._[1] !== 'route') return createStderr('% Invalid input detected');
      const me = this.modeErr(s, 'config'); if (me) return me;
      const network = x._[2];

      // Task 1 — host route on R3 toward R1's loopback
      if (rk === 'r3' && network === '192.168.1.1' && !c.ipRoute) {
        c.ipRoute = true; this.updateScore();
        return createStdout(this.guide(
          'Host route added on R3. Destination 192.168.1.1/32 — the /32 "host route" mask (255.255.255.255) means only this exact IP matches, not an entire subnet. ' +
          'Next hop 209.165.200.229 is R2\'s interface on the R2–R3 link, so R3 hands off any traffic destined for R1\'s loopback to R2 as the first transit hop. ' +
          '→ Configure the matching host route on R2.'
        ));
      }

      // Task 1 — host route on R2 forwarding toward R1
      if (rk === 'r2' && network === '192.168.1.1' && !c.ipRoute) {
        c.ipRoute = true; this.updateScore();
        return createStdout(this.guide(
          'Host route added on R2. R2 is the transit hop — when it receives R3\'s traffic for 192.168.1.1, it forwards to next hop 209.165.200.225 (R1\'s interface on the R1–R2 link). ' +
          'Both R3 and R2 use /32 masks: host routes are highly specific and won\'t accidentally match other addresses in the same range. ' +
          '→ Configure the return route on R1 so ping replies can get back to R3.'
        ));
      }

      // Task 1 — return host route on R1 toward R3's source IP
      if (rk === 'r1' && network === '209.165.200.230' && !c.ipRoute) {
        c.ipRoute = true; this.updateScore();
        return createStdout(this.guide(
          'Return host route added on R1. When R3 pings R1\'s loopback using source IP 209.165.200.230, R1 needs to know how to reply — ' +
          'this /32 route points ICMP echo replies to next hop 209.165.200.226 (R2\'s interface on the R1–R2 link). ' +
          'Without this return path, R1 would drop the reply because it has no route to 209.165.200.230. ' +
          '→ Switch to R3, type "end" to exit config mode, then "ping 192.168.1.1" to verify connectivity.'
        ));
      }

      // Task 2 — IPv4 default route on R2 toward R4
      if (rk === 'r2' && network === '0.0.0.0' && !c.ipDefaultRoute) {
        c.ipDefaultRoute = true; this.updateScore();
        return createStdout(this.guide(
          'IPv4 default route configured on R2. 0.0.0.0/0 is the "gateway of last resort" — it matches any destination not covered by a more specific route in R2\'s routing table. ' +
          'Traffic for unknown networks will be forwarded to R4 at 209.165.202.130. ' +
          'The longest-prefix-match rule means this /0 route only triggers when nothing more specific exists, so the /32 host routes from Task 1 still take priority. ' +
          '→ Now configure the IPv6 default route for Task 3.'
        ));
      }

      return createStdout('');
    },

    iosIpv6(rk, x) {
      const s = this[rk]; const c = this[rk + 'Completion'];
      if (x._[1] !== 'route') return createStderr('% Invalid input detected');
      const me = this.modeErr(s, 'config'); if (me) return me;

      // Task 3 — IPv6 default route on R2 toward R4
      if (rk === 'r2' && !c.ipv6DefaultRoute) {
        c.ipv6DefaultRoute = true; this.updateScore();
        return createStdout(this.guide(
          'IPv6 default route configured on R2. ::/0 is the IPv6 equivalent of 0.0.0.0/0 — 128 zero bits with a /0 prefix length, matching every possible IPv6 destination address. ' +
          'Unknown IPv6 traffic will forward to R4 at 2001:db8:abcd::2. ' +
          'IOS requires "ipv6 unicast-routing" to be enabled for IPv6 routing to function globally; in this simulation it is pre-configured. ' +
          'With both the IPv4 and IPv6 default routes in place, R2 now has dual-stack connectivity toward R4.'
        ));
      }

      return createStdout('');
    },

    iosPing(rk, x) {
      const me = this.modeErr(this[rk], 'exec'); if (me) return me;
      const c = this[rk + 'Completion'];
      const routesReady = this.r3Completion.ipRoute && this.r2Completion.ipRoute && this.r1Completion.ipRoute;

      const successOutput =
        'Type escape sequence to abort.<br>' +
        'Sending 5, 100-byte ICMP Echos to 192.168.1.1, timeout is 2 seconds:<br>' +
        '.!!!!<br>' +
        'Success rate is 80 percent (4/5), round-trip min/avg/max = 1/2/4 ms';

      if (rk === 'r3') {
        if (!routesReady) {
          return createStdout(
            'Type escape sequence to abort.<br>' +
            'Sending 5, 100-byte ICMP Echos to 192.168.1.1, timeout is 2 seconds:<br>' +
            '.....<br>' +
            'Success rate is 0 percent (0/5)'
          );
        }
        if (!c.pingVerify) {
          c.pingVerify = true; this.updateScore();
          return createStdout(successOutput + this.guide(
            'Ping succeeded — ".!!!!" is the expected output. The leading "." is normal: the first packet is delayed while ARP resolves the next-hop MAC address; the four "!" are successful ICMP echo replies. ' +
            '80% (4/5) confirms the full path: R3 → R2 → R1 Loopback1 and back R1 → R2 → R3 via the return host route on R1. ' +
            'All three /32 host routes are functioning correctly. → Switch to R2 and configure the default routes for Tasks 2 and 3.'
          ));
        }
        return createStdout(successOutput);
      }

      return createStdout(successOutput);
    },
  },

  components: { VueCommand },
  props: { data: { type: Object, required: true } },
};
</script>

<style>
#r1_terminal, #r2_terminal, #r3_terminal { overflow: hidden !important; }

.topology-card {
  margin-top: 1.5rem;
  background-color: #111111;
  border: 1px solid #181d2a;
  border-radius: 0.5rem;
  overflow: hidden;
  line-height: 0;
}
.topology-img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
}
</style>

